import styled from 'styled-components'
import { Alert } from 'antd'

const AntAlertStyled = styled(Alert)`
  margin: 10px 0 20px 0;
  font-style: italic;
`
export default AntAlertStyled
